/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeModeals.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, April 03, 2019 - 1:55 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      04/03/2019  NJN     File Created
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const MODAL_OPEN_SELECTWINDOW = 'MODAL_OPEN_SELECTWINDOW';
export const MODAL_CLOSE_SELECTWINDOW = 'MODAL_CLOSE_SELECTWINDOW';
export const MODAL_LOAD_SELECTWINDOW = 'MODAL_LOAD_SELECTWINDOW';
export const MODAL_CONTENTS_LOADED = 'MODAL_CONTENTS_LOADED';


// WEBPACK FOOTER //
// ./src/constants/actionTypeModals.js